module.exports = __webpack_public_path__ + "img/07.9008d480.png";